import dynamic from "next/dynamic";
import { useMemo } from "react";
import Loading from "../components/Loading";
import { useAuthUserQuery } from "../hooks";
import config from "../lib/config";
import { jsx as _jsx } from "react/jsx-runtime";
const Canvas = dynamic(() => import("../components/Canvas"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("../components/Canvas")]
  }
});
function getIdKey(user) {
  if (user) {
    return config.canvas.loginTop["vod"];
  } else {
    return config.canvas.top["vod"];
  }
}
export var __N_SSP = true;
export default function Home() {
  const {
    loading: userLoading,
    data: userData
  } = useAuthUserQuery();
  const user = userData === null || userData === void 0 ? void 0 : userData.user;
  const key = useMemo(() => {
    return getIdKey(user);
  }, [user]);
  if (userLoading) {
    return /*#__PURE__*/_jsx(Loading, {
      fixed: true
    });
  }
  return /*#__PURE__*/_jsx(Canvas, {
    idKey: key
  });
}